module.exports = __webpack_public_path__ + "img/whead-logo.7f99a2c9.svg";